export default "__VITE_ASSET__DBZnykd3__"